import React from "react";
import { PrimaryButton } from "../components/PrimaryButton";
import { COPY } from "../constants/copy";

interface ClosureSectionProps {
  onRestart: () => void;
}

export const ClosureSection: React.FC<ClosureSectionProps> = ({
  onRestart,
}) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-warmWhite dark:bg-darkBg transition-colors duration-400 py-20">
      <div className="max-w-2xl text-center space-y-12">
        <div className="animate-fade-in space-y-10">
          {/* Opening ornament */}
          <div className="text-5xl opacity-50 dark:opacity-40">✦</div>

          {/* Main closing message */}
          <div className="space-y-6">
            <p className="text-2xl md:text-3xl font-light text-deepCharcoal dark:text-darkText whitespace-pre-line leading-relaxed">
              {COPY.closure.message}
            </p>
          </div>

          {/* Closing ornament */}
          <div className="text-5xl opacity-50 dark:opacity-40">✦</div>
        </div>

        {/* Signature-style closing */}
        {/* <div className="space-y-4 pt-6">
          <div className="h-px w-24 bg-heartRed dark:bg-softRose mx-auto"></div>
          <p className="text-sm text-mutedGray dark:text-gray-400 font-light tracking-widest uppercase">
            To what comes next
          </p>
        </div> */}

        {/* CTA */}
        <div className="flex flex-col gap-4 pt-6">
          <PrimaryButton onClick={onRestart}>
            {COPY.closure.ctaStart}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};
